<template>
  <div class="cbg-white-container theme--light v-card">
    <CCol sm="12">
      <CRow>
        <CCol sm="3">
          <div class="position-relative common-search">
            <CInput label="Search by Name" v-model="search" placeholder="Name" />
            <div
              v-if="search !== ''"
              class="cross-svg center-cross-svg position-absolute"
              @click="clearSearch()"
            >
              <crossSVG />
            </div>
          </div>
        </CCol>

        <CCol sm="3">
          <CSelect label="Per page" @update:value="udpateRecordPerPage" :options="perPageOptions" />
        </CCol>
        <CCol sm="3">
          <CSelect label="Filter by status" @update:value="udpateStatus" :options="statusOptions" />
        </CCol>
      </CRow>
    </CCol>
    <CCol xs="12" lg="12">
      <CCard>
        <CCardHeader>Medicines master</CCardHeader>
        <CCardBody>
          <masterAddModal ref="masterAddModal" @refreshList="getMedicines()"></masterAddModal>
          <div class="table-div">
            <table class="table">
              <thead>
                <tr class="table-success">
                  <th>Medicine</th>
                  <th>Status</th>
                  <th>#</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(doctorMedicine, index) in doctorMedicines" :key="index">
                  <td>{{ doctorMedicine.name }}</td>
                  <td>{{ doctorMedicineStatus(doctorMedicine.status) }}</td>
                  <td>
                    <span
                      v-if="
                        permissions.includes(
                          'CAN_ADD_PHARMACY_DOCTOR_MEDICINES_MASTER'
                        )
                      "
                    >
                      <v-btn
                        class="btn btn-primary ml-1"
                        @click="showModal(doctorMedicine)"
                        v-if="!doctorMedicine.status"
                      >Add medicine to master</v-btn>
                    </span>
                    <span
                      v-if="
                        permissions.includes(
                          'CAN_REJECT_PHARMACY_DOCTOR_MEDICINES_MASTER'
                        )
                      "
                    >
                      <v-btn
                        class="btn btn-danger ml-1"
                        @click="confirm(doctorMedicine)"
                        v-if="!doctorMedicine.status"
                      >Reject</v-btn>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <pagination
              :recordPerPage="recordPerPage"
              :currentPage="currentPage"
              :total="total"
              @changePage="changePage"
            />
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </div>
</template>

<script>
import { pickSvg } from "@/views/SVG";
import config from "@/config.js";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
const masterAddModal = () => import("./../master/Add");
import debounce from "lodash/debounce";
export default {
  watch: {
    search: function(val) {
      this.getSearchResult();
    }
  },
  components: {
    masterAddModal,
    ...pickSvg("crossSVG"),
    pagination: () => import("@/views/common/Pagination")
  },

  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  data() {
    return {
      search: "",
      doctorMedicines: [],
      recordPerPage: 10,
      currentPage: 1,
      totalPage: 1,
      perPageOptions: [10, 20, 30, 50, 100],
      statusOptions: [
        { value: "all", label: "All" },
        { value: "pending", label: "Pending" },
        { value: "1", label: "Added" },
        { value: "2", label: "Rejected" }
      ],
      status: "all",
      total: 0
    };
  },
  methods: {
    clearSearch() {
      this.search = "";
    },
    getSearchResult: debounce(function(e) {
      this.currentPage = 1;
      this.getMedicines();
    }, 800),
    getMedicines() {
      let url = `${config.PHARMACY_URL}api/v1/admin/doctor-medicines`;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        status: this.status,
        search: this.search
      };
      let payload = {};
      this.$http.get(url, { params: params }).then(res => {
        this.doctorMedicines = res.body.data;
        this.totalPage = res.body.last_page;
        this.total = res.body.total;
      });
    },
    showModal(data) {
      this.$refs.masterAddModal.showModal({
        doctor_medicine_id: data.id,
        name: data.name
      });
    },
    udpateRecordPerPage(perPage) {
      this.recordPerPage = perPage;
      this.getSearchResult();
    },
    changePage(page) {
      this.currentPage = page.currentPage;
      this.getMedicines();
    },
    udpateStatus(status) {
      this.status = status;
      this.getSearchResult();
    },
    doctorMedicineStatus(status) {
      let textStatus = "";
      switch (status) {
        case null:
          textStatus = "Pending";
          break;
        case 1:
          textStatus = "Added";
          break;
        case 2:
          textStatus = "Rejected";
          break;
      }
      return textStatus;
    },
    confirm(doctorMedicine) {
      Swal.fire({
        title: "Are you sure",
        text: `You want to reject ${doctorMedicine.name} medicine?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then(result => {
        if (result.isConfirmed) {
          this.rejectDoctorMedicine(doctorMedicine);
        }
      });
    },
    rejectDoctorMedicine(doctorMedicine) {
      let url = `${config.PHARMACY_URL}api/v1/admin/doctor-medicines/${doctorMedicine.id}/reject`;
      this.$http.put(url).then(res => {
        Swal.fire(res.body.message);
        this.getMedicines();
      });
    }
  },
  created() {
    this.getMedicines();
  }
};
</script>